import { Link as RouteLink } from 'react-router-dom';
const Link = (props) => {
  const { children, to, className, onClick, ...rest } = props;
  return (
    <RouteLink
      className={`${className ? className : ''}`}
      to={to}
      onClick={onClick}
      {...rest}
    >
      {children}
    </RouteLink>
  );
};

export default Link;
